module.exports = __webpack_public_path__ + "img/complementary-care-select-fr.11c28337.jpg";